import { render, staticRenderFns } from "./RecoDesc.vue?vue&type=template&id=1b3ec2bc&"
import script from "./RecoDesc.vue?vue&type=script&lang=js&"
export * from "./RecoDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports